<template>
  <div class="wrapper" id="login">
    <div class="login-content d-flex justify-content-center">
      <div class="inner d-flex flex-column justify-content-between">
        <img src="/static/als-logo.png" class="branding" al="ALS Logo">
        <div class="login-form" v-if="!resetPassword">
          <h2>Sign in to your account</h2>
          <p>Enter your email and password below to access your account.</p>
          <p class="text-danger mb-3" id="errorMessage">{{ error }}</p>
          <form @submit.prevent="login">
            <div class="form-group">
              <label>Email Address</label>
              <input
                type="text"
                v-model="username"
                class="form-control"
                id="usernameField"
                tabindex="1"
              >
            </div>
            <div class="form-group">
              <button
                type="button"
                class="btn btn-link btn-sm float-right"
                @click="resetPassword = !resetPassword"
              >Forgot your password?</button>
              <label>Password</label>
              <input
                type="password"
                v-model="password"
                class="form-control"
                id="passwordField"
                tabindex="2"
              >
            </div>
            <div class="form-group mt-2">
              <b-form-checkbox id="rememberme" name="rememberme" v-model="rememberMe">Remember Me</b-form-checkbox>
            </div>
            <div class="form-group mt-3">
              <button
                type="submit"
                class="btn btn-primary btn-block"
                id="loginButton"
                tabindex="3"
              >Sign In</button>
            </div>
          </form>
        </div>
        <div class="reset-password" v-if="resetPassword">
          <h2>Forgot your password?</h2>
          <p>Enter your email address below and we will send you an email to help you reset your password.</p>
          <form>
            <div class="form-group">
              <label>Email Address</label>
              <input type="text" v-model="username" class="form-control" id="usernameField">
            </div>
            <div class="form-group">
              <button
                type="button"
                class="btn btn-primary"
                id="resetButton"
                @click="resetUserPassword"
              >Reset Password</button>
              <button
                type="button"
                class="btn btn-outline-secondary ml-2"
                @click="resetPassword = !resetPassword"
                id="cancelButton"
              >Cancel</button>
            </div>
          </form>
        </div>
        <div class="copyright-footer">&copy; {{ currentYear }} Analytica Laboratories Limited T/A ALS NZ</div>
      </div>
    </div>
    <div class="login-image"/>
  </div>
</template>

<script>
import router from "@/router";
import { loginUser, resetPassword } from "@/services/api";
import { storeUser, clearClients, clearUser, clearJobSort, clearSampleSort, clearResultSort } from "@/services/localstorage";
import { storeUserSession } from "@/services/usersession";
import { EventBus } from "@/services/event-bus.js";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      username: "",
      password: "",
      error: "",
      resetPassword: false,
      rememberMe: false
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    async login() {
      this.error = "";
      try {
        const result = await loginUser(
          this.username,
          this.password,
          this.rememberMe
        );
        if (result && result.status) {
          switch (result.status) {
          case 200:
            // store stuff in local storage
            this.$session.start();
            try {
              await storeUserSession(result.body, this.$session);
              await storeUser(result.body);
            } catch (e) {
              console.log(e);
            }
            router.push("overview");
            break;
          default:
            // there was an error - display an error on the page
            this.$session.destroy();
            clearClients();
            clearUser();
            this.error =
                "Your email or password is incorrect. Please try again.";
          }
        } else {
          // there was an error - display an error on the page
          this.$session.destroy();
          clearClients();
          clearUser();
          this.error = "Your email or password is incorrect. Please try again.";
        }
      } catch (ex) {
        console.log(ex);
        this.$session.destroy();
        clearUser();
        this.error = "Your email or password is incorrect. Please try again.";
      }
    },
    async resetUserPassword() {
      this.$session.destroy();
      clearUser();
      // todo - add some error handling here
      const result = await resetPassword(this.username);
      router.push("/resetpassword");
    }
  },
  created() {
    // always hide the loader
    EventBus.$emit("hideLoader");
    // reset login status on page create
    if (this.$session.exists()) {
      this.$session.destroy();
    }
    clearUser();
    // always clear the stored search settings
    clearJobSort();
    clearSampleSort();
    clearResultSort();
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";

.wrapper {
  height: 100vh;
}

.login-content {
  height: 100%;
  width: 30%;
  float: left;
  h2 {
    margin-bottom: 20px;
  }
  .branding {
    width: 200px;
  }
  .inner {
    width: 500px;
    height: 100%;
    padding: 50px;
  }
}

.login-image {
  position: relative;
  background-image: url("../../static/login-photo.jpg");
  background-size: contain; 
  background-position: 100%; 
  background-repeat: no-repeat;
  height: 100%;
  width: 70%;
  float: right;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue